export const Asterisk = () => <span className="ml-1 text-red-500">*</span>;
